export default __webpack_public_path__ + "static/media/Rubik-VariableFont_wght.ea640765.ttf";